import { render } from "./TaskView.vue?vue&type=template&id=9d0e5412"
import script from "./TaskView.vue?vue&type=script&lang=js"
export * from "./TaskView.vue?vue&type=script&lang=js"

import "./TaskView.vue?vue&type=style&index=0&id=9d0e5412&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__